import { useHistory } from "react-router-dom";

const NoOIDCAppAccess = ({ message }) => {
    const history = useHistory();

    return (
        <div style={{ textAlign: 'center', paddingTop: '100px' }}>
            <img src="../../PermissionDenied.png" />
            <div style={{ textAlign: 'center', fontSize: 'xx-large', fontWeight: '600' }}>
                {message === "No matching state found in storage" ? "Please login again" : message}
            </div>

            <div style={{ textAlign: 'center', fontSize: 'x-large', fontWeight: '400', paddingBottom: "10px" }}>
                {
                    message === "No matching state found in storage" ?
                        "" : "Please contact your Administrators for assistance with getting access"
                }
            </div>
        </div>
    )
}

export default NoOIDCAppAccess;
